
import './index.less'
import Nav from './components/Nav/index.jsx'
import CompMain from './components/compMain/index.jsx'
import Tips1 from './components/tips1/index.jsx'
import Tips2 from './components/tips2/index.jsx'
import Popup from './components/popup/index1.jsx'
import { useState } from 'react'
import clone from './utils/clone.js'
import React from 'react'
import SetPage from './components/setPage/index.jsx'
import SetPageNav from './components/setPage/nav.jsx'
import { getMaterialList1 } from '@/api/nativePAGE.js'
import Mantle from './components/Mantle/index.jsx'
import 'antd/dist/antd.css'

console.log(React)
export default function NewNativePromotionPage(props) {
  const [ifon, setIfon] = useState({
    components: clone(props.components, true),
    pressItem: null,
    pressItem1: null,
    pressX: null,
    pressY: null,
    moveX: null,
    moveY: null,
    activeComps: initActives(props.components),
    selectItem: null,
    isPopup: false,
    rotationIndex: 0,
    pageType: 'createPage'
  })
  const [sharingSettings, setSharingSettings] = useState({
    title: props.information.title || '',
    describe: props.information.describe || '',
    name: props.information.name || '新建微信原生推广页' + Math.random().toString(16).slice(2, 8),
    thumbnail: props.information.thumbnail || {},
    common_page_id: props.information.common_page_id || null
  })

  window.aa = ifon
  window.bb = sharingSettings

  return (
    <div className='newNativePromotionPage'>
      {ifon.pageType === 'createPage' ? <div className='newNativePromotionPage_headArea'>
        {/* <div className='headArea_no1'>
          <div className='no1_left'>
            <h2 className='title' style={{ color: '#fff' }}>新建原生推广页</h2>
          </div>
          <div className='no2_right'>
            <ul className='right_option'>
              <li className='item'>
                <span className='item_text'>选择模板</span>
              </li>
              <li className='item'>
                <span className='item_text'>编辑原生推广页</span>
              </li>
              <li className='item'>
                <span className='item_text'>分享设置</span>
              </li>
            </ul>
          </div>
        </div> */}
        <div className='headArea_no2'>
          <div className='no2_left'>
            <div className='left_arrow' onClick={() => {
              props.account_id ? props.go_adq(props.account_id) : props.go_public && props.go_public()
            }}>
              <i className='icon'>
                <svg className='adui-button-leftIcon adui-icon-base' width='18' height='18' viewBox='0 0 18 18' fill='var(--gray-700)' ><path d='M9.15411 4.75495C9.34899 4.56007 9.34943 4.24425 9.15509 4.04883L8.8051 3.69689C8.61007 3.50076 8.29286 3.50024 8.09719 3.69573L3.14601 8.64208C3.04692 8.74107 2.99805 8.87129 2.99942 9.00109C2.99806 9.13088 3.04692 9.26111 3.14601 9.3601L8.09719 14.3064C8.29286 14.5019 8.61007 14.5014 8.8051 14.3053L9.15509 13.9533C9.34943 13.7579 9.34899 13.4421 9.15411 13.2472L5.65688 9.74999H14.5C14.7761 9.74999 15 9.52614 15 9.24999V8.74999C15 8.47385 14.7761 8.24999 14.5 8.24999H5.65907L9.15411 4.75495Z' fillRule='evenodd'></path></svg>
              </i>
            </div>
            <div className='left_input'>
              <input className='input' value={sharingSettings.name} onChange={(e) => {
                setSharingSettings({
                  ...sharingSettings,
                  name: e.target.value
                })
              }} />
              <i className='icon'>
                <svg fill='currentColor' preserveAspectRatio='xMidYMid meet' height='16' width='16' viewBox='0 0 32 32' className='icon-edQB0KK2VG'><path d='M4 23v5h5l15-15-5-5L4 23zM27.613 9.387c.52-.52.52-1.36 0-1.88l-3.12-3.12c-.52-.52-1.36-.52-1.88 0l-2.44 2.44 5 5 2.44-2.44z'></path></svg>
              </i>
            </div>
          </div>
          <div className='no2_center'></div>
          <div className='no2_right'>
            <button className='button'>
              <span className='button_text' onClick={() => {
                setIfon({
                  ...ifon,
                  pageType: 'setPage'
                })
              }}>下一步</span>
              <i className='button_icon'>
                <svg width='18' height='18' viewBox='0 0 18 18'><path d='M9.14258 4.75495C8.94771 4.56007 8.94727 4.24425 9.1416 4.04883L9.49159 3.69689C9.68663 3.50076 10.0038 3.50024 10.1995 3.69573L15.1507 8.64208C15.2498 8.74107 15.2986 8.87129 15.2973 9.00109C15.2986 9.13088 15.2498 9.26111 15.1507 9.3601L10.1995 14.3064C10.0038 14.5019 9.68663 14.5014 9.49159 14.3053L9.1416 13.9533C8.94727 13.7579 8.94771 13.4421 9.14258 13.2472L12.6398 9.74999H3.5C3.22386 9.74999 3 9.52614 3 9.24999V8.74999C3 8.47385 3.22386 8.24999 3.5 8.24999H12.6376L9.14258 4.75495Z' ></path></svg>
              </i>
            </button>
          </div>
        </div>
      </div> : <SetPageNav
        myReturn={() => {
          setIfon({
            ...ifon,
            pageType: 'createPage'
          })
        }}
        components={ifon.components}
        sharingSettings={sharingSettings}
        beBasedOn={props['be-based-on']}
        account_id={props.account_id}
        go_public={props.go_public}
        go_adq={props.go_adq}
      ></SetPageNav>}

      <div className='newNativePromotionPage_main'>

        {ifon.pageType === 'createPage' ? <React.Fragment>
          <div className='main_nav'>
            <Nav
              pressAndHold={(obj) => {
                handleNavPress(obj, ifon, setIfon)
              }}
              move={(obj) => {
                handleNavMove(obj, ifon, setIfon)
              }}
              up={(obj) => {
                handleNavUp(obj, ifon, setIfon)
              }}
              activeComps={ifon.activeComps}
              beBasedOn={props['be-based-on']}
            ></Nav>
          </div>

          <div className='main_main'>
            <CompMain
              components={ifon.components}
              pressItem={ifon.pressItem}
              comps={ifon.comps}
              pressAndHold={(obj) => {
                handleItemPress(obj, ifon, setIfon)
              }}
              move={(obj) => {
                handleItemMove(obj, ifon, setIfon)
              }}
              up={(obj) => {
                handleItemUp(obj, ifon, setIfon)
              }}
              addFlipping={() => {
                addFlipping(ifon, setIfon)
              }}
              deleteFlipping={(index) => {
                deleteFlipping(index, ifon, setIfon)
              }}
              deleteItem={(id) => {
                deleteItem(id, ifon, setIfon)
              }}
              selectItem={ifon.selectItem}
              hoistPopup={() => {
                ifon.isPopup = true
                setIfon({
                  ...ifon
                })
              }}
              setBack={(components) => {
                setIfon({
                  ...ifon,
                  components
                })
              }}
            ></CompMain>

          </div>

          <div className='main_side'>
            {(ifon.selectItem && ifon.selectItem.sideComp) && <ifon.selectItem.sideComp
              key={ifon.selectItem.id}
              ifon={ifon.selectItem.ifon}
              mySetIfon={(myIfon) => {
                mySetIfon(myIfon, ifon, setIfon)
              }}
              hoistPopup={(index = null) => {
                setIfon({
                  ...ifon,
                  isPopup: true,
                  rotationIndex: index === null ? ifon.rotationIndex : index
                })
              }}
              components={ifon.components}
            />}
          </div></React.Fragment> : <SetPage sharingSettings={sharingSettings} setSharingSettings={(ifon) => {
          setSharingSettings(ifon)
        }}
        hoistPopup={() => {
          setIfon({
            ...ifon,
            isPopup: true,
            pageType: 'setPage'
          })
        }}
        ></SetPage>}
      </div>

      {ifon.isPopup && <Mantle>
        <Popup
          close={() => {
            setIfon({
              ...ifon,
              isPopup: false,
              pageType: 'createPage',
              popupItem: null
            })
          }}
          rule={(page, callback) => {
            rule(page, callback, ifon, setIfon)
          }}
          paging={(page, callback) => {
            rule(page, callback, ifon, setIfon)
          }}
          change={(item) => {
            if (!item) {
              window.alert('请选择')
              return
            }
            determine(item, ifon, setIfon, sharingSettings, setSharingSettings)
          }}
        >
          {(props) => {
            return (<div className={`popupItem ${props.active ? props.active.id === props.item.id ? 'active' : '' : ''}`}>
              <div className='popupItem_box'>
                { props.item.type === 1 && <img className='box_img' src={props.item.path} /> }
              </div>
              <div className='popupItem_ifon'></div>
            </div>)
          }}
        </Popup>
      </Mantle>}

    </div >
  )
}

NewNativePromotionPage.defaultProps = {
  components: [{
    back: '#ffffff',
    id: Math.random(),
    comps: [{
      comp: Tips1,
      name: 'Tips1',
      id: Math.random()
    }]
  }],
  information: {
    title: '',
    describe: ''
  },
  name: ''
}

function handleNavPress(obj, ifon, setIfon) {
  if (!obj.ifon.name.startsWith('top')) {
    addComp(ifon, 0, ifon.components[0].comps.length, 0, {
      id: Math.random(),
      comp: Tips2,
      name: 'tips2'
    })
  }
  setIfon({
    ...ifon,
    pressItem: obj.ifon,
    pressX: obj.pressX,
    pressY: obj.pressY
  })
}

function handleNavMove(obj, ifon, setIfon) {
  if (ifon.pressItem.name.startsWith('top_')) {
    return
  }

  for (let i = 0; i < ifon.components.length; i++) {
    const compBoxIfon = ifon.components[i].compBox.getBoundingClientRect()
    const contentIfon = ifon.components[i].content.getBoundingClientRect()
    const bool1 = (obj.moveX >= compBoxIfon.x) && (obj.moveX <= (compBoxIfon.x + compBoxIfon.width))
    const bool2 = (obj.moveY >= compBoxIfon.y) && (obj.moveY <= (compBoxIfon.y + compBoxIfon.height))
    const bool3 = (obj.moveX >= contentIfon.x) && (obj.moveX <= (contentIfon.x + contentIfon.width))
    const bool4 = (obj.moveY >= contentIfon.y) && (obj.moveY <= (contentIfon.y + contentIfon.height))

    let tips2Index
    const s = ifon.components[i].comps.filter((item, index) => {
      if (item.comp === Tips2) {
        tips2Index = index
      }
      return item.comp === Tips2
    })
    let lindex, tindex

    if (bool1 && bool2) {
      if (bool3 && bool4) {
        for (let l = 0; l < ifon.components[i].comps.length; l++) {
          const calCompIfon = ifon.components[i].comps[l].calComp.getBoundingClientRect()
          const bool5 = (obj.moveX >= calCompIfon.x) && (obj.moveX <= (calCompIfon.x + calCompIfon.width))
          const bool6 = (obj.moveY >= calCompIfon.y) && (obj.moveY <= (calCompIfon.y + calCompIfon.height))
          const half = calCompIfon.height / 2 + calCompIfon.y

          if (bool5 && bool6 && (ifon.components[i].comps[l].comp !== Tips2)) {
            if (s.length) {
              const comp = ifon.components[i].comps[tips2Index]

              if (i === 0 && l === 0) {
                if (half < obj.moveY) {
                  lindex = tips2Index + 1
                  tindex = 1
                  displacement(ifon.components[i].comps, lindex, tindex, comp)
                  break
                }
              } else {
                if (tips2Index > l) {
                  lindex = tips2Index + 1
                  if (half < obj.moveY) {
                    tindex = l + 1
                  } else {
                    tindex = l
                  }
                } else {
                  lindex = tips2Index
                  if (half < obj.moveY) {
                    tindex = l + 1
                  } else {
                    tindex = l
                  }
                }
              }

              displacement(ifon.components[i].comps, lindex, tindex, comp)
              break
            } else {
              deleteTips2(ifon)

              if (half < obj.moveY) {
                addComp(ifon, i, l + 1, 0, {
                  id: Math.random(),
                  name: 'tips2',
                  comp: Tips2
                })
                break
              } else {
                addComp(ifon, i, l, 0, {
                  id: Math.random(),
                  name: 'tips2',
                  comp: Tips2
                })
                break
              }
            }
          }
        }
      } else {
        if (s.length) {
          const item = ifon.components[i].comps[tips2Index]
          displacement(ifon.components[i].comps, tips2Index, ifon.components[i].comps.length, item)
          break
        } else {
          deleteTips2(ifon)
          addComp(ifon, i, ifon.components[i].comps.length, 0, {
            id: Math.random(),
            name: 'tips2',
            comp: Tips2
          })
          break
        }
      }
    }
  }

  setIfon({
    ...ifon,
    moveX: obj.moveX,
    moveY: obj.moveY
  })
}

function handleNavUp(obj, ifon, setIfon) {
  if (obj.upX === ifon.pressX && obj.upY === ifon.pressY) {
    const item = {
      id: Math.random(),
      comp: ifon.pressItem.contentComp,
      name: ifon.pressItem.name,
      copyComp: ifon.pressItem.contentCopyComp,
      sideComp: ifon.pressItem.sideComp,
      ifon: clone(ifon.pressItem.ifon, true)
    }
    if (obj.ifon.name.startsWith('top')) {
      addComp(ifon, 0, 0, 1, item)
      ifon.selectItem = item
    } else if (ifon.pressItem.name === 'marketing_suspension_comp') {
      if (ifon.components.length === 1) {
        item.original = 0
        const obj = item
        addComp(ifon, 0, ifon.components[0].comps.length, 0, obj)
        ifon.selectItem = item
      } else {
        item.original = ifon.components.length - 1
        const obj = item
        addComp(ifon, ifon.components.length - 1, ifon.components[0].comps.length, 0, obj)
        ifon.selectItem = obj
      }
    } else {
      addComp(ifon, 0, ifon.components[0].comps.length, 0, item)
      ifon.selectItem = item
    }

    ifon.activeComps.includes(ifon.pressItem.name) || ifon.activeComps.push(ifon.pressItem.name)
  } else {
    for (let i = 0; i < ifon.components.length; i++) {
      for (let l = 0; l < ifon.components[i].comps.length; l++) {
        const calCompIfon = ifon.components[i].comps[l].calComp.getBoundingClientRect()
        const bool5 = (obj.upX >= calCompIfon.x) && (obj.upX <= (calCompIfon.x + calCompIfon.width))
        const bool6 = (obj.upY >= calCompIfon.y) && (obj.upY <= (calCompIfon.y + calCompIfon.height))

        if (bool5 && bool6 && ((ifon.components[i].comps[l].comp === Tips1) || (ifon.components[i].comps[l].comp === Tips2))) {
          const item = {
            id: Math.random(),
            name: ifon.pressItem.name,
            comp: ifon.pressItem.contentComp,
            copyComp: ifon.pressItem.contentCopyComp,
            sideComp: ifon.pressItem.sideComp,
            ifon: clone(ifon.pressItem.ifon, true)
          }
          if (ifon.pressItem.name.startsWith('top_')) {
            if ((ifon.components[i].comps[l].comp === Tips1) && (i === 0) && (l === 0)) {
              displacement(ifon.components[i].comps, 1, 0, item)
              ifon.activeComps.includes(ifon.pressItem.name) || ifon.activeComps.push(ifon.pressItem.name)
              ifon.selectItem = item
              break
            }
          } else if (ifon.components[i].comps[l].comp === Tips2) {
            if (ifon.pressItem.name === 'marketing_suspension_comp') {
              if (i === (ifon.components.length - 1)) {
                const obj = { ...item, original: ifon.components.length - 1 }
                addComp(ifon, i, l, 0, obj)
                ifon.activeComps.includes(ifon.pressItem.name) || ifon.activeComps.push(ifon.pressItem.name)
                ifon.selectItem = obj
                break
              } else {
                alert('该组件只支持放在最后一页')
                break
              }
            } else {
              addComp(ifon, i, l, 0, item)
              ifon.activeComps.includes(ifon.pressItem.name) || ifon.activeComps.push(ifon.pressItem.name)
              ifon.selectItem = item
              break
            }
          }
        }
      }
    }
  }

  deleteTips2(ifon)

  setIfon({
    ...ifon,
    pressItem: null,
    pressX: null,
    pressY: null,
    moveX: null,
    moveY: null
  })
}

function handleItemPress(obj, ifon, setIfon) {
  setIfon({
    ...ifon,
    pressItem1: obj.ifon,
    pressX: obj.pressX,
    pressY: obj.pressY
  })
}

function handleItemMove(obj, ifon, setIfon) {
  for (let i = 0; i < ifon.components.length; i++) {
    const compBoxIfon = ifon.components[i].compBox.getBoundingClientRect()
    const contentIfon = ifon.components[i].content.getBoundingClientRect()
    const bool1 = (obj.moveX >= compBoxIfon.x) && (obj.moveX <= (compBoxIfon.x + compBoxIfon.width))
    const bool2 = (obj.moveY >= compBoxIfon.y) && (obj.moveY <= (compBoxIfon.y + compBoxIfon.height))
    const bool3 = (obj.moveX >= contentIfon.x) && (obj.moveX <= (contentIfon.x + contentIfon.width))
    const bool4 = (obj.moveY >= contentIfon.y) && (obj.moveY <= (contentIfon.y + contentIfon.height))
    let tips2Index
    const s = ifon.components[i].comps.filter((item, index) => {
      if (item.comp === Tips2) {
        tips2Index = index
      }
      return item.comp === Tips2
    })

    if (bool1 && bool2) {
      if (bool3 && bool4) {
        for (let l = 0; l < ifon.components[i].comps.length; l++) {
          const calCompIfon = ifon.components[i].comps[l].calComp.getBoundingClientRect()
          const bool5 = (obj.moveX >= calCompIfon.x) && (obj.moveX <= (calCompIfon.x + calCompIfon.width))
          const bool6 = (obj.moveY >= calCompIfon.y) && (obj.moveY <= (calCompIfon.y + calCompIfon.height))
          const half = calCompIfon.height / 2 + calCompIfon.y
          const pressIfon = getIndexes(ifon.components, ifon.pressItem1.id)
          const targetIfon = getIndexes(ifon.components, ifon.components[i].comps[l].id)

          if (bool5 && bool6 && (ifon.components[i].comps[l].comp !== Tips2) && (ifon.pressItem1.id !== ifon.components[i].comps[l].id)) {
            if (s.length) {
              const comp = ifon.components[i].comps[tips2Index]
              let lindex, tindex

              if (pressIfon.father === targetIfon.father) {
                if (i === 0 && l === 0) {
                  if (half < obj.moveY) {
                    if (((i === 0) && (pressIfon.son > 1)) || i !== 0) {
                      lindex = tips2Index + 1
                      tindex = 1
                      displacement(ifon.components[i].comps, lindex, tindex, comp)
                      break
                    }
                  }
                } else {
                  if (tips2Index < l) {
                    lindex = tips2Index

                    if ((pressIfon.son + 1 === targetIfon.son) || (pressIfon.son - 1 === targetIfon.son)) {
                      if (pressIfon.son + 1 === targetIfon.son) {
                        if (half < obj.moveY) {
                          tindex = l + 1
                          displacement(ifon.components[i].comps, lindex, tindex, comp)
                          break
                        }
                      } else {
                        if (half > obj.moveY) {
                          tindex = l
                          displacement(ifon.components[i].comps, lindex, tindex, comp)
                          break
                        }
                      }
                    } else {
                      if (half < obj.moveY) {
                        tindex = l + 1
                      } else {
                        tindex = l
                      }

                      displacement(ifon.components[i].comps, lindex, tindex, comp)
                      break
                    }
                  } else {
                    lindex = tips2Index + 1

                    if ((pressIfon.son + 1 === targetIfon.son) || (pressIfon.son - 1 === targetIfon.son)) {
                      if (pressIfon.son + 1 === targetIfon.son) {
                        if (half > obj.moveY) {
                          tindex = l + 1
                          displacement(ifon.components[i].comps, lindex, tindex, comp)
                          break
                        }
                      } else {
                        if (half < obj.moveY) {
                          tindex = l
                          displacement(ifon.components[i].comps, lindex, tindex, comp)
                          break
                        }
                      }
                    } else {
                      if (half < obj.moveY) {
                        tindex = l + 1
                      } else {
                        tindex = l
                      }
                      displacement(ifon.components[i].comps, lindex, tindex, comp)
                      break
                    }
                  }
                }
              } else {
                if (i === 0 && l === 0) {
                  if (half < obj.moveY) {
                    if (((i === 0) && (pressIfon.son > 1)) || i !== 0) {
                      lindex = tips2Index + 1
                      tindex = 1
                      displacement(ifon.components[i].comps, lindex, tindex, comp)
                      break
                    }
                  }
                } else {
                  if (tips2Index < l) {
                    lindex = tips2Index
                    if (half < obj.moveY) {
                      tindex = l + 1
                    } else {
                      tindex = l
                    }
                  } else {
                    lindex = tips2Index + 1
                    if (half < obj.moveY) {
                      tindex = l + 1
                    } else {
                      tindex = l
                    }
                  }

                  displacement(ifon.components[i].comps, lindex, tindex, comp)
                  break
                }
              }
            } else {
              if (pressIfon.father === targetIfon.father) {
                let indexl
                const item = {
                  id: Math.random(),
                  name: 'tips2',
                  comp: Tips2
                }

                if (i === 0 && l === 0) {
                  if (obj.moveY > half) {
                    if (((i === 0) && (pressIfon.son > 1)) || i !== 0) {
                      deleteTips2(ifon)
                      indexl = 1
                      addComp(ifon, i, indexl, 0, item)
                      break
                    }
                  }
                } else {
                  deleteTips2(ifon)

                  if ((pressIfon.son + 1 === targetIfon.son) || (pressIfon.son - 1 === targetIfon.son)) {
                    if (pressIfon.son + 1 === targetIfon.son) {
                      if (obj.moveY > half) {
                        indexl = l + 1
                        addComp(ifon, i, indexl, 0, item)
                        break
                      }
                    } else {
                      if (obj.moveY < half) {
                        indexl = l
                        addComp(ifon, i, indexl, 0, item)
                        break
                      }
                    }
                  } else {
                    if (half > obj.moveY) {
                      indexl = l
                    } else {
                      indexl = l + 1
                    }
                    addComp(ifon, i, indexl, 0, item)
                    break
                  }
                }
              } else {
                deleteTips2(ifon)
                let indexl

                if (i === 0 && l === 0) {
                  if (obj.moveY > half) {
                    indexl = 1
                    addComp(ifon, i, indexl, 0, {
                      id: Math.random(),
                      name: 'tips2',
                      comp: Tips2
                    })
                    break
                  }
                } else {
                  if (half < obj.moveY) {
                    indexl = l + 1
                  } else {
                    indexl = l
                  }

                  addComp(ifon, i, indexl, 0, {
                    id: Math.random(),
                    name: 'tips2',
                    comp: Tips2
                  })
                  break
                }
              }
            }
          }
        }
      } else {
        const pressIfon = getIndexes(ifon.components, ifon.pressItem1.id)
        let half
        let targetIfon
        console.log(half)
        for (let i = 0; i < ifon.components.length; i++) {
          for (let l = 0; l < ifon.components[i].comps.length; l++) {
            const calCompIfon = ifon.components[i].comps[l].calComp.getBoundingClientRect()
            const bool5 = (obj.moveX >= calCompIfon.x) && (obj.moveX <= (calCompIfon.x + calCompIfon.width))
            const bool6 = (obj.moveY >= calCompIfon.y) && (obj.moveY <= (calCompIfon.y + calCompIfon.height))

            if (bool5 && bool6) {
              half = calCompIfon.height / 2 + calCompIfon.y
              targetIfon = getIndexes(ifon.components, ifon.components[i].comps[l].id)
              break
            }
          }
          if (targetIfon) {
            break
          }
        }

        if (targetIfon) {
          if (pressIfon.father === targetIfon.father) {
            break
          } else {
            if (s.length) {
              const comp = ifon.components[i].comps[tips2Index]
              let lindex, tindex

              if (targetIfon.son === ifon.components[i].comps.length - 1) {
                lindex = tips2Index
                tindex = ifon.components[i].comps.length - 1
              } else {
                lindex = tips2Index
                tindex = ifon.components[i].comps.length
              }

              displacement(ifon.components[i].comps, lindex, tindex, comp)
              break
            } else {
              deleteTips2(ifon)

              if (targetIfon.son === ifon.components[i].comps.length - 1) {
                addComp(ifon, targetIfon.father, ifon.components[i].comps.length - 1, 0, {
                  id: Math.random(),
                  name: 'tips2',
                  comp: Tips2
                })
                break
              } else {
                addComp(ifon, targetIfon.father, ifon.components[i].comps.length, 0, {
                  id: Math.random(),
                  name: 'tips2',
                  comp: Tips2
                })
                break
              }
            }
          }
        } else {
          let bool6 = true

          const s1 = ifon.components[i].comps.filter((item) => {
            return item.name === 'marketing_suspension_comp'
          })

          if (s1.length && (getIndexes(ifon.components, s1[0].id).father === pressIfon.father)) {
            if ((getIndexes(ifon.components, s1[0].id).son === (ifon.components[i].comps.length - 1)) && (pressIfon.son === (ifon.components[i].comps.length - 2))) {
              bool6 = false
            }
          }

          if (((pressIfon.father === i) && (pressIfon.son < (ifon.components[i].comps.length - 1)) && bool6) || (pressIfon.father !== i)) {
            if (s.length) {
              const comp = ifon.components[i].comps[tips2Index]

              displacement(ifon.components[i].comps, tips2Index, ifon.components[i].comps.length, comp)
              break
            } else {
              deleteTips2(ifon)
              addComp(ifon, i, ifon.components[i].comps.length, 0, {
                id: Math.random(),
                name: 'tips2',
                comp: Tips2
              })
              break
            }
          }
        }
      }
    }
  }

  setIfon({
    ...ifon,
    moveX: obj.moveX,
    moveY: obj.moveY
  })
}

function handleItemUp(obj, ifon, setIfon) {
  if ((ifon.pressX === obj.upX) && (ifon.pressY === obj.upY)) {
    ifon.selectItem = ifon.pressItem1
  } else {
    for (let i = 0; i < ifon.components.length; i++) {
      const contentIfon = ifon.components[i].content.getBoundingClientRect()
      const bool3 = (obj.upX >= contentIfon.x) && (obj.upX <= (contentIfon.x + contentIfon.width))
      const bool4 = (obj.upY >= contentIfon.y) && (obj.upY <= (contentIfon.y + contentIfon.height))

      if (bool3 && bool4) {
        for (let l = 0; l < ifon.components[i].comps.length; l++) {
          const calCompIfon = ifon.components[i].comps[l].calComp.getBoundingClientRect()
          const bool5 = (obj.upX >= calCompIfon.x) && (obj.upX <= (calCompIfon.x + calCompIfon.width))
          const bool6 = (obj.upY >= calCompIfon.y) && (obj.upY <= (calCompIfon.y + calCompIfon.height))

          if (bool5 && bool6 && (ifon.components[i].comps[l].comp === Tips2)) {
            const pressIfon = getIndexes(ifon.components, ifon.pressItem1.id)
            const item = ifon.pressItem1

            addComp(ifon, i, l, 1, item)
            ifon.components[pressIfon.father].comps.splice(pressIfon.son, 1)
            break
          }
        }
      }
    }
  }

  deleteTips2(ifon)
  setIfon({
    ...ifon
  })
}

function addComp(ifon, father, son, term, comp) {
  ifon.components[father].comps.splice(son, term, comp)
}

function deleteTips2(ifon) {
  for (let i = 0; i < ifon.components.length; i++) {
    ifon.components[i].comps = ifon.components[i].comps.filter((item) => {
      return item.comp !== Tips2
    })
  }
}

function displacement(arr, lindex, tindex, com) {
  arr.splice(tindex, 0, com)
  arr.splice(lindex, 1)
}

function getIndexes(arr, id) {
  for (let i = 0; i < arr.length; i++) {
    for (let l = 0; l < arr[i].comps.length; l++) {
      if (arr[i].comps[l].id === id) {
        return {
          son: l,
          father: i
        }
      }
    }
  }
}

function deleteItem(id, ifon, setIfon) {
  const itemIfon = getIndexes(ifon.components, id)
  const name = ifon.components[itemIfon.father].comps[itemIfon.son].name

  if (name.startsWith('top_')) {
    displacement(ifon.components[itemIfon.father].comps, itemIfon.son, 1, {
      id: Math.random(),
      name: 'Tips1',
      comp: Tips1
    })
    ifon.activeComps = ifon.activeComps.filter((name1) => {
      return name1 !== name
    })
  } else {
    ifon.components[itemIfon.father].comps.splice(itemIfon.son, 1)
    let bool = false
    for (let i = 0; i < ifon.components.length; i++) {
      for (let l = 0; l < ifon.components[i].comps.length; l++) {
        if (ifon.components[i].comps[l].name === name) {
          bool = true
          break
        }
      }
    }
    if (!bool) {
      ifon.activeComps = ifon.activeComps.filter((name1) => {
        return name1 !== name
      })
    }
  }

  if (ifon.selectItem && (ifon.selectItem.id === id)) {
    ifon.selectItem = null
  }

  setIfon({
    ...ifon
  })
}

function addFlipping(ifon, setIfon) {
  let suspension

  for (let i = 0; i < ifon.components.length; i++) {
    for (let l = 0; l < ifon.components[i].comps.length; l++) {
      if (ifon.components[i].comps[l].name === 'marketing_suspension_comp') {
        suspension = ifon.components[i].comps[l]
        ifon.components[i].comps.splice(l, 1)
        break
      }
    }
    if (suspension) {
      break
    }
  }

  ifon.components.push({
    back: '#ffffff',
    comps: [],
    id: Math.random()
  })

  if (suspension) {
    ifon.components[ifon.components.length - 1].comps.push(suspension)
  }

  setIfon({
    ...ifon
  })
}

function deleteFlipping(index, ifon, setIfon) {
  const s = ifon.components[index].comps.filter((item) => {
    return item.name === 'marketing_suspension_comp'
  })
  ifon.components.splice(index, 1)
  if (s.length && (s[0].original !== index)) {
    ifon.components[ifon.components.length - 1].comps.push(s[0])
  }
  setIfon({
    ...ifon
  })
}

async function rule(page, callback, ifon, setIfon) {
  if (ifon.pageType === 'createPage') {
    if (ifon.selectItem.name === 'top_image_comp') {
      let width, height
      if (ifon.selectItem.ifon.ad_location === 'sns') {
        if (ifon.selectItem.ifon.outer_style) {
          width = 800
          height = 450
        } else {
          width = 800
          height = 800
        }
      } else {
        width = 800
        height = 800
      }

      const data = await getMaterialList1({
        type: 1,
        page,
        width,
        height
      })
      callback({
        datas: data.data.list,
        total: data.data.total
      })
    } else if (ifon.selectItem.name === 'top_carousel_comp') {
      const data = await getMaterialList1({
        type: 1,
        page,
        width: 800,
        height: 800
      })
      callback({
        datas: data.data.list,
        total: data.data.total
      })
    } else if (ifon.selectItem.name === 'top_video_comp') {
      let width = null
      let height = null
      if (ifon.selectItem.ifon.ad_location === 'sns') {
        if (ifon.selectItem.ifon.outer_style) {
          width = 640
          height = 480
        } else {
          width = 640
          height = 360
        }
      } else {
        width = 750
        height = 1334
      }
      const data = await getMaterialList1({
        type: 2,
        page,
        width,
        height
      })
      callback({
        datas: data.data.list,
        total: data.data.total
      })
    } else if (ifon.selectItem.name === 'basics_image_comp') {
      const data = await getMaterialList1({
        type: 1,
        page
      })
      callback({
        datas: data.data.list,
        total: data.data.total,
        type: 'img'
      })
    } else if (ifon.selectItem.name === 'marketing_suspension_comp') {
      const data = await getMaterialList1({
        type: 1,
        page,
        width: 96,
        height: 96
      })
      callback({
        datas: data.data.list,
        total: data.data.total,
        type: 'img'
      })
    }
  } else if (ifon.pageType === 'setPage') {
    const data = await getMaterialList1({
      type: 1,
      page
    })
    callback({
      datas: data.data.list,
      total: data.data.total
    })
  }
}

function determine(item, ifon, setIfon, sharingSettings, setSharingSettings) {
  if (ifon.pageType === 'createPage') {
    const obj = { ...item, zwidth: Math.floor(item.width / 2.133), zheight: Math.floor(item.height / 2.133) }
    if (ifon.selectItem.name === 'top_image_comp') {
      if (ifon.selectItem.ifon.ad_location === 'sns') {
        if (ifon.selectItem.ifon.outer_style) {
          ifon.selectItem.ifon.imgeIfon.sns.cardAdvertising = obj
        } else {
          ifon.selectItem.ifon.imgeIfon.sns.regularAdvertising = obj
        }
      } else {
        ifon.selectItem.ifon.imgeIfon.gzh = obj
      }
    } else if (ifon.selectItem.name === 'top_carousel_comp') {
      ifon.selectItem.ifon.image_id_list[ifon.rotationIndex] = { ...item, zwidth: Math.floor(item.width / 2.133), zheight: Math.floor(item.height / 2.133) }
    } else if (ifon.selectItem.name === 'basics_image_comp') {
      ifon.selectItem.ifon.imageIfon = item
    } else if (ifon.selectItem.name === 'marketing_suspension_comp') {
      ifon.selectItem.ifon.imageIfon = item
    }
    setIfon({
      ...ifon,
      isPopup: false
    })
  } else if (ifon.pageType === 'setPage') {
    sharingSettings.thumbnail = item
    setSharingSettings({
      ...sharingSettings
    })
    setIfon({
      ...ifon,
      isPopup: false
    })
  }
}

function mySetIfon(myIfon, ifon, setIfon) {
  ifon.selectItem.ifon = myIfon
  setIfon({
    ...ifon
  })
}

function initActives(components) {
  const as = []
  for (let i = 0; i < components.length; i++) {
    for (let l = 0; l < components[i].comps.length; l++) {
      const name = components[i].comps[l].name
      as.includes(name) || as.push(name)
    }
  }

  return as
}
